import { APITransport } from '@client/transports/api';

export const TargetingService = {
  get() {
    return APITransport.post({
      path: '/rest/domain/execute/getabm'
    });
  },
  async preview(body = {}) {
    return APITransport.post({
      path: '/rest/domain/execute/runabm',
      body
    });
  },
  async update(body = {}) {
    return APITransport.post({
      path: '/rest/domain/execute/saveabm',
      body
    });
  }
};
